import React from "react";
import { CgSpinnerAlt } from "react-icons/cg";

const Loading = () => {
  return (
    <div className="justfiy-content flex items-center ">
      <CgSpinnerAlt className="animate-spin text-5xl text-white" />
    </div>
  );
};

export default Loading;
